<template>
  <div class="home">
    <AppLayout>
      <section id="settings-categories">
        <div class="container">
          <h4 class="fw-bold">Audit Logs</h4>

          <table
            class="table table-hover"
            id="logsTable"
            style="width: 100% !important"
          >
            <thead>
              <tr>
                <th>No.</th>
                <th>Date/Time</th>
                <th>User</th>
                <th>Entity</th>
                <th>Action</th>
                <th>Log</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(log, index) in filteredLogs" :key="log.id">
                <td>{{ index + 1 }}</td>
                <td>{{ log.createdAt }}</td>
                <td>
                  {{ log.User.id === user.id ? 'You' : log.User.name }}
                </td>
                <td>{{ log.entity }}</td>
                <td>{{ log.action }}</td>
                <td>{{ log.details }}</td>
              </tr>
            </tbody>
          </table>

          <LoaderItem v-if="loading" />
        </div>
      </section>
    </AppLayout>
  </div>
</template>


<script>
  import { docFooter } from '../../utils/common'
  import LoaderItem from '../../components/LoaderItem.vue'
  import AppLayout from '../../components/AppLayout.vue';
  import 'datatables.net-vue3';
  import 'datatables.net-bs5';
  import "datatables.net-buttons-bs5";
  import "datatables.net-responsive-bs5";
  import $ from 'jquery';
  import 'jszip';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.colVis.js';
  import 'datatables.net-buttons/js/buttons.print.js';

  import Swal from 'sweetalert2'
  import axios from 'axios'
  import { filterRecords } from '@/utils/common';
export default {
    name: 'SettingsCategoryPage',
    components:{
      AppLayout,
      LoaderItem
    },

    data: () => ({
        token: JSON.parse(localStorage.getItem('access_token')),
        urlServer:process.env.VUE_APP_URL,
        profile: {},
        user: "",
        logs: [], 
        filteredLogs: [],
        searchQuery: "",
        dataTable: null,
        processedData: [],
        loading: false,

      
    }),

    mounted(){
        this.fetchLogs()
        this.setupUser()
    },

    methods:{
        searchActivity(){
        this.filteredLogs = filterRecords(this.logs, this.searchQuery)
        },

        async setupUser(){
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/users/profile', requestOptions)
            const data = await res.json()
            //console.log("User Data",data)
            if(data.status == true){
              this.user = data.user;
            }  
        },


        preprocessData(rawData) {
          return rawData.map(item => {
            return {
              indexNo: "1",
              user: item.User.name,
              createdAt: this.formatDate(item.createdAt,"true"),
              entity: item.entity,
              action: item.action,
              log: item.details
             
            };
          });
        },

        
    initializeDataTable() {
      try {
        this.dataTable = $(this.$el).find('#logsTable').DataTable({
          responsive: true,
          language: {
            paginate: {
              previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
              next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
            },
          },
          dom: 'frtip',
          data: this.processedData,
          columns: [
            { data: null },
            { data: 'createdAt'},
            { data: 'user' },
            { data: 'entity'},
            { data: 'action' },
            { data: 'log' },
          ],
          columnDefs: [
            {
              targets: 0,
              searchable: false,
              orderable: false,
              render: (data, type, row, meta) => {
                return meta.row + 1;
              },
            },
          ],
        });
      } catch (error) {
        console.log({ error })
      }
    },

    customizePDF(doc) {
      const profile = JSON.parse(localStorage.getItem('profile'))
      //const logoBase64 = this.convertToBase64(logo)
      //console.log(logoBase64)
      doc.pageMargins = [40, 40, 40, 40]; // Set margins for the entire page
      doc.defaultStyle.columnGap = 0
      doc.content[1].fillColor = '#ffffff'

      doc.header = () => {
        return {
          columns: [
            {
              width: '*',
              columns: [
                /* {
                     image: logoBase64,
                     width: 150, // Adjust the width as needed
                 },*/
                {
                  text: profile?.businessName,
                  alignment: 'left',
                  margin: [40, 15, 0, 40], // Adjust margins as needed
                  color: '#000000', // Orange color
                  bold: true,
                  fontSize: 14,

                }
              ]
            },
            {
              width: '*',
              stack: [
                {
                  text: 'Audit Logs',
                  alignment: 'right',
                  margin: [0, 15, 50, 0],
                  fontSize: 12,
                  color: '#000000'
                },
                {  
                  alignment: 'right',
                  margin: [300, 0, 0, 0],
                  width: '*',
                  columns: [
                    {
                      width: 'auto',
                      text: 'Date:',
                      alignment: 'right',
                      margin: [0, 0, 10, 0],
                      bold: true,
                    },
                    {
                      width: 'auto',
                      text: `${this.formatDate(new Date(), "true")}`,
                      alignment: 'right',
                      margin: [0, 0, 50, 0],
                      fontSize: 9
                    }
                  ]
                }
              ]
            }
          ],
          fillColor: '#000000'
        };
      },

        doc.footer = (currentPage, pageCount) => docFooter(currentPage, pageCount)

      doc.styles.title = {
        color: '#000000',
        fontSize: 13,
        margin: [80, 0, 0, 40],
      };
    },


        async fetchLogs() {
          try {
            const response = await axios.get(`${process.env.VUE_APP_URL}/logs`, { 
              headers: { 
                'Accept': 'application/json',
                'Authorization': 'Bearer '+this.token 
              }
            }
            );

            if (response.status == 200) {
              this.logs = response.data
              this.filteredLogs = this.logs
              console.log(this.logs)
              this.processedData = this.preprocessData(this.logs)
              this.initializeDataTable()
            } else {
              console.error('Unexpected status code:', response.status);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch logs. Please try again later.'
              });
            }
          }catch (error) {
            console.error('Error fetching logs:', error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to fetch logs. Please try again later.'
            });
        }
      },
    },
    watch: {
      searchQuery(newValue, oldValue) {
        if (newValue.trim() !== '' && newValue.trim() !== oldValue.trim()) {
          this.filteredLogs = filterRecords(this.logs,newValue);
        } else {
          this.filteredWarehouses = this.warehouses;
        }
      }
    },
}

</script>

<style scoped>
    .card {
        border: 0;
        border-radius: 0.2rem;
    }
    .rounded-bottom {
        border-bottom-left-radius: 0.375rem !important;
        border-bottom-right-radius: 0.375rem !important;
    }
    .avatar-xxl {
        height: 7.5rem;
        width: 7.5rem;
    }
    .nav-lt-tab {
        border-top: 1px solid var(--dashui-border-color);
    }
    .px-4 {
        padding-left: 1rem!important;
        padding-right: 1rem!important;
    }

    .avatar-sm {
        height: 2rem;
        width: 2rem;
    }

    .nav-lt-tab .nav-item {
        margin: -0.0625rem 1rem 0;
    }
    .nav-lt-tab .nav-item .nav-link {
        border-radius: 0;
        border-top: 2px solid transparent;
        color: var(--dashui-gray-600);
        font-weight: 500;
        padding: 1rem 0;
    }

    .pt-20 {
        padding-top: 8rem!important;
    }

    .avatar-xxl.avatar-indicators:before {
        bottom: 5px;
        height: 16%;
        right: 17%;
        width: 16%;
    }
    .avatar-online:before {
        background-color: #198754;
    }
    .avatar-indicators:before {
        border: 2px solid #FFF;
        border-radius: 50%;
        bottom: 0;
        content: "";
        display: table;
        height: 30%;
        position: absolute;
        right: 5%;
        width: 30%;
    }

    .avatar-xxl {
        height: 7.5rem;
        width: 7.5rem;
    }
    .mt-n10 {
        margin-top: -3rem!important;
    }
    .me-2 {
        margin-right: 0.5rem!important;
    }
    .align-items-end {
        align-items: flex-end!important;
    }
    .rounded-circle {
        border-radius: 50%!important;
    }
    .border-2 {
        --dashui-border-width: 2px;
    }
    .border {
        border: 1px solid #dcdcdc !important;
    }

    .py-6 {
        padding-bottom: 1.5rem!important;
        padding-top: 1.5rem!important;
    }

    .bg-gray-300 {
        --dashui-bg-opacity: 1;
        background-color: #cbd5e1!important;
    }

    .mb-6 {
        margin-bottom: 1.5rem!important;
    }
    .align-items-center {
        align-items: center!important;
    }


    .mb-4 {
        margin-bottom: 1rem!important;
    }

    .mb-8 {
        margin-bottom: 2rem!important;
    }
    .shadow-none {
        box-shadow: none!important;
    }

    .card>.list-group:last-child {
        border-bottom-left-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
        border-bottom-width: 0;
    }
    .card>.list-group:first-child {
        border-top-left-radius: 0.5rem;
        border-top-right-radius: 0.5rem;
        border-top-width: 0;
    }
    .card>.list-group {
        border-bottom: inherit;
        border-top: inherit;
    }
    .card-body{
        padding: 12px 14px !important;
        background-color: #ccccdf !important;
    }



</style>